import React from 'react';
import { BAIQL_TEMPLATES } from '../data/baiqlTemplates';

const Badge = ({ text }) => (
  <span style={{ background:'#111827', color:'#d1d5db', borderRadius:6, padding:'2px 6px', fontSize:12 }}>{text}</span>
);

const TemplateCard = ({ t, onUse }) => (
  <div className="dashboard-card" style={{ padding:12, display:'grid', gap:8 }}>
    <div style={{ display:'flex', gap:8, alignItems:'center' }}>
      <div style={{ fontWeight:600 }}>{t.name}</div>
      <Badge text={t.batchType} />
    </div>
    <div style={{ color:'#6b7280' }}>{t.description}</div>
    <pre style={{ background:'#0b1020', color:'#e5e7eb', borderRadius:6, padding:10, margin:0, fontSize:12, whiteSpace:'pre-wrap' }}>{t.code.trim().slice(0,400)}{t.code.length>400?'\n…':''}</pre>
    <div style={{ display:'flex', justifyContent:'flex-end' }}>
      <button className="action-button primary" onClick={() => onUse(t)}>Use Template</button>
    </div>
  </div>
);

const BAIQLTemplateGallery = ({ isOpen, onClose, onUseTemplate }) => {
  if (!isOpen) return null;
  const cats = [
    { key:'Content Generation', label:'Content Generation' },
    { key:'Document Analysis', label:'Document Analysis' },
    { key:'Custom Analysis', label:'Custom Analysis' },
    { key:'Grading with Rubric', label:'Grading with Rubric' },
    { key:'Multi-step Processing', label:'Multi-step Processing' }
  ];
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="app-modal" onClick={e=>e.stopPropagation()} style={{ width:'min(980px, 95vw)' }}>
        <div className="app-modal-header">
          <strong>BAIQL Templates</strong>
          <button className="close" onClick={onClose}>×</button>
        </div>
        <div className="app-modal-body" style={{ maxHeight: '70vh', overflow:'auto' }}>
          {cats.map(c => (
            <div key={c.key} style={{ marginBottom: 16 }}>
              <h4 style={{ margin:'8px 0' }}>{c.label}</h4>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))', gap:12 }}>
                {BAIQL_TEMPLATES.filter(t => t.category === c.key).map(t => (
                  <TemplateCard key={t.id} t={t} onUse={onUseTemplate} />
                ))}
              </div>
            </div>
          ))}
          {/* Quick Start */}
          <div className="dashboard-card" style={{ padding:12, marginTop:12 }}>
            <div style={{ fontWeight:600 }}>Quick Start</div>
            <div style={{ color:'#6b7280' }}>Try a template to get started, then customize variables and paths. See the docs for details.</div>
            <div style={{ marginTop:8 }}>
              <a href="/docs#baiql" onClick={e=>{ e.preventDefault(); window.location.href='/docs#baiql'; }}>BAIQL Documentation</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BAIQLTemplateGallery;


